import React from 'react';

import {
  DescriptionItem,
  DescriptionList,
  TypographyListItem,
  TypographyList,
  makeStyles,
} from '@gogame/components';
import { useNumberFormat } from '@gogame/intl-ts';

const useStyles = makeStyles({
  rowDirection: {
    '& > div': {
      display: 'flex',
    },
  },
});

const Country = ({ selected, excluded }) => {
  const classes = useStyles();

  const isSelected = selected?.length;
  const hasValue = Boolean(selected?.length || excluded?.length);

  return hasValue ? (
    <React.Fragment>
      {!isSelected && 'All except:'}
      <TypographyList
        bullet
        limit={5}
        unitsLabel={'Countries'}
        className={classes.rowDirection}
      >
        {(isSelected ? selected : excluded)?.map(({ name }) => (
          <TypographyListItem>{name}</TypographyListItem>
        ))}
      </TypographyList>
    </React.Fragment>
  ) : (
    'All'
  );
};
const AFFILIATE = 'affiliate';

const GeneralSection = ({ data }) => {
  const numberFormatter = useNumberFormat();
  const getRedeemText = (data) => {
    if (!data?.redemptionBreakdown) {
      return '';
    }

    return data?.usageLimit
      ? `${numberFormatter(
          data?.redemptionBreakdown?.total
        )} of ${numberFormatter(data?.usageLimit)} ${
          data.isSet ? '' : '(usage limit)'
        }`
      : `${numberFormatter(data?.redemptionBreakdown?.total)}`;
  };
  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem
        placeholder={'—'}
        label={'Type'}
        field={'isSet'}
        value={data?.isSet ? 'Set of personal code' : 'Public'}
      />
      <DescriptionItem placeholder={'—'} label={'Code'} field={'code'} />
      <DescriptionItem
        placeholder={'—'}
        label={'Redeemed'}
        field={'redemptionBreakdown'}
        value={getRedeemText(data)}
      />
      <DescriptionItem
        placeholder={'—'}
        label={'Activity type'}
        field={'activityType.name'}
      />
      <DescriptionItem
        placeholder={'—'}
        label={'Attribution'}
        field={'attributionType'}
      />
      <DescriptionItem
        label={'Multiple redemptions'}
        field={'multiRedemption'}
        valueParser={(v) => (v === true ? 'Yes' : v === false ? 'No' : v)}
      />
      <DescriptionItem
        label={'Max redemptions per player'}
        field={'maxRedemptionsPerUser'}
      />
      <DescriptionItem
        label={'Cooldown days'}
        field={'multiRedemptionCooldownPeriod'}
      />
      <DescriptionItem
        label={'Activity days'}
        field={'multiRedemptionActivityPeriod'}
      />
      <DescriptionItem
        placeholder={'—'}
        label={'Application'}
        field={'application.name'}
      />
      <DescriptionItem
        label={"Optimove's campaign ID"}
        field={'optimoveCampaigns'}
        type={'typographyList'}
        unitsLabel={'campaigns'}
        limit={3}
      />
      {!data.activityType?.isCrm ? (
        <React.Fragment>
          <DescriptionItem
            label={'Platforms'}
            field={'platforms'}
            type={'typographyList'}
            unitsLabel={'Platforms'}
            listType={'bullet'}
            item={({ name, value }) => (
              <TypographyListItem>
                {value} {name}
              </TypographyListItem>
            )}
          />
          <DescriptionItem
            label={'Countries'}
            field={'countries'}
            valueParser={Country}
          />
          <DescriptionItem
            placeholder={'—'}
            label={'Affiliate'}
            field={`${AFFILIATE}.name`}
          />
        </React.Fragment>
      ) : null}
      <DescriptionItem
        placeholder={'—'}
        label={'Activity period'}
        type={'dateRange'}
        field={'activityPeriod'}
        template={'LL'}
        timeZone={'utc'}
      />
      <DescriptionItem
        label={'Rewards'}
        field={'rewards'}
        type={'typographyList'}
        unitsLabel={'Rewards'}
        listType={'bullet'}
        item={({ name, value, compensations }) => (
          <TypographyListItem>
            {value ? numberFormatter(value) : value} {name}{' '}
            {compensations?.length
              ? `(Compensation: ${compensations
                  .map(
                    ({ name, value }) =>
                      `${value ? numberFormatter(value) : value} ${name}`
                  )
                  .join(', ')})`
              : null}
          </TypographyListItem>
        )}
      />
      <DescriptionItem
        placeholder={'—'}
        label={'Description'}
        field={'comment'}
      />
    </DescriptionList>
  );
};

export default GeneralSection;
